import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { StoreState } from '..';
import errorHandler from '../../errorHandler';
import apiRest from '../../services/apiRest';
import { addSnackbar } from '../snacks/snacksActions';
import { TransactionsAction, TransactionsActionTypes } from './transactionsTypes';

export function getTransactions():
  ThunkAction<Promise<void>, StoreState, undefined, TransactionsAction> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const { dateTo, dateFrom, type, resource, category } = getState().transactionsState.filters;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: TransactionsActionTypes.GET_TRANSACTIONS_START,
      });
      const { data: transactions } = await apiRest({
        method: 'get',
        url: `/transactions/`,
        params: {
          churchId,
          dateTo,
          dateFrom,
          type,
          resource,
          category,
        },
      });
      dispatch({
        type: TransactionsActionTypes.GET_TRANSACTIONS_SUCCESS,
        transactions,
      });
    } catch (e) {
      errorHandler(e);
      dispatch({ type: TransactionsActionTypes.GET_TRANSACTIONS_ERROR });
    }
  };
}

export function getResumeYear():
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: TransactionsActionTypes.GET_RESUME_YEAR_START,
      });
      const { data } = await apiRest.get('transactions/resume', {
        params: { churchId },
      });
      dispatch({
        type: TransactionsActionTypes.GET_RESUME_YEAR_SUCCESS,
        resume: data,
      });
    } catch (e) {
      errorHandler(e);
      dispatch({ type: TransactionsActionTypes.GET_RESUME_YEAR_ERROR });
    }
  };
}

export function getResumeDay(day: string):
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: TransactionsActionTypes.GET_RESUME_DAY_START,
      });
      const { data } = await apiRest.get(`transactions/resume/day/${day}`, {
        params: { churchId },
      });
      dispatch({
        type: TransactionsActionTypes.GET_RESUME_DAY_SUCCESS,
        resumeDay: data,
      });
    } catch (e) {
      errorHandler(e);
      dispatch({ type: TransactionsActionTypes.GET_RESUME_DAY_ERROR });
    }
  };
}

export function saveTransaction(form: any):
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const {
        transactions,
        selectedIndex,
      } = getState().transactionsState;

      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }

      const data: any = {
        value: parseFloat(form.value.replace('R$ ', '').replace('.', '').replace(',', '.')),
        parcel: parseInt(form.parcel, 10) || 1,
        date: form.date,
        categoryId: form.categoryId,
        status: form.status,
        historic: form.historic,
        resource: form.resource,
      };
      if (form.type === 'Despesa') {
        data.value = -data.value;
        data.provider = form.provider;
        data.costCenter = form.costCenter;
        data.fiscalNote = form.fiscalNote;
      } else {
        data.source = form.source;
        data.paymentMethod = form.paymentMethod;
        if (form.isMember) {
          data.personId = form.personId || null;
        } else {
          data.personName = form.personName || null;
        }
      }

      dispatch({ type: TransactionsActionTypes.SAVE_TRANSACTION_START });
      const transactionOrig = selectedIndex !== null && transactions[selectedIndex];

      await apiRest({
        method: transactionOrig ? 'PUT' : 'POST',
        url: `/transactions/${transactionOrig ? transactionOrig.id : ''}`,
        params: { churchId },
        data,
      });

      dispatch({ type: TransactionsActionTypes.SAVE_TRANSACTION_SUCCESS });
      dispatch(addSnackbar('Registro salvo com sucesso', { variant: 'success' }));
      dispatch(getTransactions());
    } catch (e) {
      errorHandler(e);
      dispatch({ type: TransactionsActionTypes.SAVE_TRANSACTION_ERROR });
    }
  };
}

export function editingStart(selectedIndex?: number): TransactionsAction {
  return {
    type: TransactionsActionTypes.EDITING_START,
    index: selectedIndex,
  };
}

export function setTransactionsFilters(
  dateTo: string,
  dateFrom: string,
  type: string,
  resource: string,
  category: string,
): TransactionsAction {
  return {
    type: TransactionsActionTypes.SET_TRANSACTIONS_FILTERS,
    filters: { dateTo, dateFrom, type, resource, category },
  };
}
